import { Template } from "src/lib/templates";
import { personalInfoTemplate } from "./personalInfoTemplate";

export const template: Template = {
  name: "Checkout Form",
  template: [{ name: "isResponsable", type: { name: "string" } }, { name: "useDeliveryAddress", type: { name: "boolean" } }, personalInfoTemplate],
};
